module.exports = __webpack_public_path__ + "static/media/playson.1bb565b5.svg";